import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';

export const donationsSlice = (state: RootState) => state.entities.donations;

export const donationById = selectorsFactory.createEntityByIdSelector(donationsSlice);
